<div [formGroup]="parentForm">
    <!--<mat-form-field class="example-full-width" style="margin: 5px; width: 250px;" *ngIf="!isKendo">
    </mat-form-field>-->
    <div *ngIf="!isKendo" style="margin:5px;width:250px;">
        <input matInput #autoTrigger="matAutocompleteTrigger" [placeholder]="placeholder" [formControlName]="ctrlName" [attr.aria-label]="ariaLabel" [matAutocomplete]="city"
               [attr.disabled]="isDisabled" [attr.required]="isRequired" (keydown.enter)="$event.preventDefault(); chooseActiveCity($event)" (keydown.Tab)="chooseActiveCity($event)"
               (blur)="optionBlurred()" class="form-control">
        <mat-autocomplete #city="matAutocomplete" [displayWith]="displayCity" (optionSelected)="optionChanged($event)" (focusout)="optionBlurred()" [panelWidth]="'400px'">
            <mat-option *ngFor="let city of filteredCities | async" [value]="city">
                {{ isCityStateZip ? city.cityStateZip : city.cityST }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="!isValid()">{{errorDetail}}</mat-error>
    </div>
    <div *ngIf="isKendo">
        <!--https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/filtering/-->
        <kendo-autocomplete [data]="cities"
                            [formControlName]="ctrlName"
                            valueField="cityST"
                            [filterable]="true"
                            (filterChange)="getCityLookup($event)"
                            (valueChange)="optionChanged($event)"
                            class="form-control"
                            placeholder="{{placeholder}}">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                <div style="line-height:1.2;height:50px;">
                    <span *ngIf="isCityStateZip">{{dataItem.cityStateZip}}</span>
                    <span *ngIf="!isCityStateZip">{{dataItem.cityST}}</span>
                </div>
            </ng-template>
        </kendo-autocomplete>
    </div>
</div>